import Skeleton from 'react-loading-skeleton';
import {
  ReceiverData,
  ReceiverName,
  ReceiverNotes,
} from './receiver-card.styles';

const ReceiverCardSkeleton = () => (
  <>
    <ReceiverName>
      <Skeleton
        width='85%'
        height='1.6rem'
        borderRadius={6}
      />
    </ReceiverName>

    <ReceiverData>
      <Skeleton
        width='55%'
        height='1.3rem'
        borderRadius={6}
      />
    </ReceiverData>

    <ReceiverData>
      <Skeleton
        width='65%'
        height='1.3rem'
        borderRadius={6}
      />
    </ReceiverData>

    <ReceiverData>
      <Skeleton
        width='80%'
        height='1.3rem'
        borderRadius={6}
      />
    </ReceiverData>

    <ReceiverNotes>
      <Skeleton
        width='50%'
        height='1.3rem'
        borderRadius={6}
      />
    </ReceiverNotes>
  </>
);

export default ReceiverCardSkeleton;
